import React from 'react';
import classnames from 'classnames';
import { useFlag } from '../../../redux/flags/hooks';
import s from './UserSymbol.scss';
export var UserSymbol = function (_a) {
    var userType = _a.userType, className = _a.className;
    var newCoreEnabled = useFlag('core_badges');
    var isNewCoreType = userType === 'core_access' ||
        userType === 'core_pro' ||
        userType === 'core_plus';
    var amendedUserType = !newCoreEnabled && isNewCoreType ? 'premium' : userType;
    if (userType === 'regular' || userType === 'buyer' || userType === 'banned') {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['symbol'], s[amendedUserType]), "aria-hidden": true }));
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;
//# sourceMappingURL=UserSymbol.js.map